import React from 'react';

export default function PlanoAcaoPage() {
  return (
    <div>
      Qualidade - Plano de Ação (placeholder).
    </div>
  );
}

